// app/javascript/projects/components/ProjectsDisplay.jsx

import React, {useCallback, useEffect} from 'react';
import AccountSingleButton from 'projects/components/AccountSingleButton'
import { useSubscription } from '../../hooks/subscriptions/queries';
import { useEndTrial } from '../../hooks/subscriptions/mutations';
import { useCurrentUser } from '../../hooks/users/queries';
import { isFreeAccount, isOwner, isSeparatelyInvoiced, formatSubscriptionPrice } from '../../utils/subscriptionUtils';
import { useTeamModal } from '../../hooks/subscriptions/useTeamModal';
import { useLocation, useHistory } from 'react-router-dom';
import AccountPageConstants from 'constants/AccountPageConstants';

function BillingModalEndTrial() {
  const { navigateToPage } = useTeamModal();
  const location = useLocation();
  const history = useHistory();
  const isOnUpgradePage = location.pathname.includes('upgrade');
  
  // Get subscription data from hooks
  const { data: subscription, isLoading: subscriptionLoading } = useSubscription();
  const { data: currentUser, isLoading: userLoading } = useCurrentUser();
  const plan = subscription?.plan || {};
  
  const freeAccount = isFreeAccount(subscription);
  const userIsOwner = isOwner(subscription, currentUser?.id);
  const subscriptionIsSeparatelyInvoiced = isSeparatelyInvoiced(subscription);
  
  const endTrialMutation = useEndTrial();

  const upgradeSubscription = useCallback(() => {
    if (subscription?.id) {
      endTrialMutation.mutate(subscription.id);
    }
  }, [subscription?.id, endTrialMutation]);
  
  // Handle successful mutation
  useEffect(() => {
    if (endTrialMutation.isSuccess) {
      // If we're on the upgrade page, navigate to /users first
      if (isOnUpgradePage) {
        history.push('/users');
      }
      navigateToPage(AccountPageConstants.PLAN_AND_BILLING);
    }
  }, [endTrialMutation.isSuccess, navigateToPage, isOnUpgradePage, history]);

  // Only check eligibility and redirect after data is loaded
  if (!subscriptionLoading && !userLoading) {
    if (subscription?.status && (
      subscription.status !== 'trialing'
      || userIsOwner === false
      || freeAccount
      || subscriptionIsSeparatelyInvoiced
    )) {
      if (isOnUpgradePage) {
        // If on upgrade page and not eligible, redirect back to /users
        history.push('/users');
      } else {
        // Otherwise navigate to billing page
        navigateToPage(AccountPageConstants.PLAN_AND_BILLING);
      }
      return null;
    }
  }


  //const subscription = this.props.subscription ? this.props.subscription : {};
  return (
    <div>
      <AccountSingleButton
        error={endTrialMutation.error && {
          error: true,
          message: endTrialMutation.error?.response?.data?.error || 'An error occurred, could not upgrade subscription'
        }}
        loading={endTrialMutation.isPending}
        header="Upgrade to paid subscription"
        button="Upgrade to Paid Subscription"
        disclaimer={`By upgrading, you agree to be immediately charged and to automatic ${plan?.interval || 'month'}ly billing until you choose to cancel.`}
        onClick={upgradeSubscription}
        body={
          <p>
            Unlock full access to all Delve features by upgrading to a paid subscription for {formatSubscriptionPrice(subscription)}.
            Your account will be charged immediately, and you'll enjoy uninterrupted access to all features.
          </p>
        }
      />
    </div>
  );
}

export default BillingModalEndTrial;
